export const DEFAULT_LIMIT = 10;
export const DEFAULT_PAGE = 1;
export const DATE_FORMAT = "MMM d, yyyy, HH:mm";
// Theme
export const DEFAULT_THEME = {
  call_center_banner: false,
  copyright_company_name: "Berkeley Payment Solutions Inc.",
  e6_migration: false,
  hrb_limit_update_banner: false,
  language_configuration: true,
  processor: "",
  theme: {
    activate_cardholder_agreement_en: "",
    activate_cardholder_agreement_fr: "",
    activate_electronic_com_consent_en: "",
    activate_electronic_com_consent_fr: "",
    activate_privacy_policy_en: "",
    activate_privacy_policy_fr: "",
    background: "#482764",
    cbc_footer: {
      contact_us: {
        title_en: "",
        title_fr: "",
        url: "",
      },
      faq: {
        title_en: "",
        title_fr: "",
        url: "",
      },
      privacy_policy: {
        title_en: "",
        title_fr: "",
        url: "",
      },
      terms: {
        title_en: "",
        title_fr: "",
        url: "",
      },
    },
    favicon: "https://images.dev.pungle.co/images/berkeley-favicon.png",
    footer_text: "#FFF",
    header_background: "#482764",
    header_text: "#FFF",
    logo: "https://images.dev.pungle.co/images/berkeley-logo.png",
    logo_fr: "",
    logo_redirect_url: null,
    primary: "#4341AA",
    primary_text: "#FFF",
    register_terms_of_use_en: "",
    register_terms_of_use_fr: "",
    secondary: "#7CCBD1",
    secondary_text: "#2C2C2C",
    tertiary: "#7E81BE",
    text: "#5D6F84",
    title: "#4341AA",
    virtual_card_art:
      "https://images.dev.pungle.co/images/virtual-card-default.png",
    virtual_card_terms:
      "https://images.dev.pungle.co/images/Terms+and+Conditions.pdf",
    virtual_card_text: "#6F808B",
  },
};
export const DEFAULT_THEME_SUBDOMAIN = "UNBRANDED";
// Subdomain Prefixes
export const DEV_SUBDOMAIN_PREFIX = "dev";
export const STAGING_SUBDOMAIN_PREFIX = "staging";
export const DEV_APEX_DOMAIN = "dev-berkeleypayment";
export const STAGING_APEX_DOMAIN = "stage-berkeleypayment";
//modules
export const MOD_CARD_ISSUING = "card_issuing";
export const MOD_CARD_HOLDERS = "card_holders";
export const MOD_ORDER = "order";
export const MOD_PROGRAMS = "programs";
export const MOD_SEARCH_ORDER = "search_order";
export const MOD_OFFICE = "office";
export const MOD_SHIPPING_ADDRESS = "shipping_address";
export const MOD_SELL_ORDER = "sell_order";
export const MOD_BATCH_SELL_ORDER = "batch_sell_order";
export const MOD_CARD_BALANCE = "card_balance";
export const MOD_REPLACE_CARDS = "replace_cards";
export const MOD_SHIFT_REPORT = "shift_report";
export const MOD_KIOSK_REPORT = "kiosk_report";
export const MOD_USERS = "users";
export const MOD_AUDIT_LOGS = "audit_logs";
export const MOD_REPORT = "report";
export const MOD_VOID_CARDS = "void_sell_order_item_by_id";
export const SELL_ORDER_LANDING = "sell_order_landing";
export const MOD_REPORTS = "program_reports";
export const MOD_CORPORATE_CUSTOMERS = "corporate_customers";
export const MOD_COMBINE_CARDS = "combine_cards";
export const MOD_SELL_SPECIALTY_ITEMS = "sell_specialty_items";

// Dynamic RBAC permission resource keys (from bps-go, keyed "category.feature").
export const RBAC_RESOURCE_USERS = "settings.users";
export const RBAC_RESOURCE_USER_ROLES = "settings.user_roles";
export const RBAC_RESOURCE_USERS_UNLOCK = "users_unlock";
export const USER_ROLES_PATH = "/settings/user-roles";

// Maps a sidebar/route module (MOD_* key) to the dynamic RBAC permission that
// gates its page (resource = catalog name minus its level). Hides modules a
// custom-role user lacks, in the sidebar and route guards. Modules with no
// entry keep their company-config / static-role gating.
export const MODULE_PERMISSIONS = {
  [MOD_CARD_ISSUING]: { resource: "card_issuing", access: "read" },
  [MOD_CARD_HOLDERS]: { resource: "cardholders", access: "read" },
  [MOD_PROGRAMS]: { resource: "programs", access: "read" },
  [MOD_ORDER]: { resource: "card_orders", access: "read" },
  [MOD_SEARCH_ORDER]: { resource: "sell_orders", access: "read" },
  [MOD_SELL_ORDER]: { resource: "sell_orders", access: "read" },
  [MOD_COMBINE_CARDS]: { resource: "sell_orders", access: "read" },
  [MOD_SHIFT_REPORT]: { resource: "sell_orders", access: "read" },
  [MOD_KIOSK_REPORT]: { resource: "sell_orders", access: "read" },
  [MOD_BATCH_SELL_ORDER]: {
    resource: "sell_order.batch_sell_order",
    access: "read",
  },
  [MOD_REPLACE_CARDS]: { resource: "sell_order.replace_card", access: "read" },
  [MOD_CARD_BALANCE]: {
    resource: "sell_order.check_card_balance",
    access: "read",
  },
  [MOD_VOID_CARDS]: { resource: "sell_orders_items", access: "read" },
  [MOD_OFFICE]: { resource: "offices.offices", access: "read" },
  [MOD_SHIPPING_ADDRESS]: {
    resource: "offices.shipping_addresses",
    access: "read",
  },
  [MOD_REPORT]: { resource: "company_reporting", access: "read" },
  [MOD_REPORTS]: { resource: "reports.reports", access: "read" },
  [MOD_USERS]: { resource: "settings.users", access: "read" },
  [MOD_CORPORATE_CUSTOMERS]: { resource: "corporate_customers", access: "read" },
  [MOD_SELL_SPECIALTY_ITEMS]: { resource: "sell_specialty_items", access: "write" },
  [MOD_AUDIT_LOGS]: { resource: "audit_logs", access: "read" },
};

export const DEFAULT_SERVICE_CONFIGURATION = {
  [MOD_CARD_ISSUING]: true,
  [MOD_CARD_HOLDERS]: false,
  [MOD_ORDER]: true,
  [MOD_PROGRAMS]: false,
  [MOD_SEARCH_ORDER]: true,
  [MOD_OFFICE]: true,
  [MOD_SHIPPING_ADDRESS]: true,
  [MOD_SELL_ORDER]: true,
  [MOD_BATCH_SELL_ORDER]: true,
  [MOD_CARD_BALANCE]: true,
  [MOD_REPLACE_CARDS]: true,
  [MOD_COMBINE_CARDS]: true,
  [MOD_SHIFT_REPORT]: true,
  [MOD_KIOSK_REPORT]: true,
  [MOD_USERS]: true,
  [MOD_AUDIT_LOGS]: true,
  [MOD_REPORT]: true,
  [MOD_VOID_CARDS]: false,
  [SELL_ORDER_LANDING]: false,
  [MOD_REPORTS]: false,
  [MOD_CORPORATE_CUSTOMERS]: false,
  [MOD_SELL_SPECIALTY_ITEMS]: false
};
